import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Peça',
    parent: 'traveiculo',
    path: '/transporte/trapeca/:traVeiculoId',
    name: 'trapeca',
    component: () => import('@/views/transporte/trapeca/CadastroComGrid.vue'),
    meta: {
      permissions: [eTipoPermissao.VEICULOSNOVO_MENU_1100200299],
    },
    goesToMenu: false,
  },
];
